import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTheme } from '../../../middleware/ThemeContext';
import { Theme } from '../../../utils/themes';
import StyledText from '../../StyledComponents/StyledText';
import { TempSettings } from '../../../types/types';
import { hexToRgba } from '../../../utils/helper';
import StyledInput from '../../StyledComponents/StyledInput';
import { StyledHorizontalLine } from '../../StyledComponents/Styledhr';
import { Radio } from '@mui/material';
import LeftAlignIcon from '../../../assets/icons/LeftAlignIcon';
import CenterAlignIcon from '../../../assets/icons/CenterAlignIcon';
import RightAlignIcon from '../../../assets/icons/RightAlignIcon';
import StyledRadio from '../../StyledComponents/StyledRadio';
import AMSSelect from '../../AMSSelect';
import { Form } from 'react-bootstrap';
import StyledTextEditor from '../../StyledComponents/TextEditor/StyledTextEditor';

const ParagraphProperties = ({ updateTempSetting, tempSettings }: { updateTempSetting: (key: string, value: any) => void, tempSettings: TempSettings }) => {
    const { theme } = useTheme();
    const headingOptions = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
    const fontWeightOptions = ['Regular', 'Medium', 'Bold'];
    const textAlignmentOptions = [{ id: 'Left', icon: <LeftAlignIcon /> }, { id: 'Center', icon: <CenterAlignIcon /> }, { id: 'Right', icon: <RightAlignIcon /> }];
    const getNumericFontSize = (value?: string) => value ? value.replace(/px$/i, '') : '28';
    const [paragraphFontSizeInput, setParagraphFontSizeInput] = useState(getNumericFontSize(tempSettings.paragraphFontSize));

    useEffect(() => {
        setParagraphFontSizeInput(getNumericFontSize(tempSettings.paragraphFontSize));
    }, [tempSettings.paragraphFontSize]);

    const handleParagraphFontSizeChange = (value: string) => {
        if (value === '') {
            setParagraphFontSizeInput('');
            return;
        }

        if (!/^\d+$/.test(value)) {
            return;
        }

        setParagraphFontSizeInput(value);
        updateTempSetting('paragraphFontSize', `${value}px`);
    };

    const handleParagraphFontSizeBlur = () => {
        if (paragraphFontSizeInput !== '') return;

        setParagraphFontSizeInput('0');
        updateTempSetting('paragraphFontSize', '0px');
    };

    return (
        <Container theme={theme}>
            <StyledText fontSize='13px' fontWeight={600} textColor={theme.CorporateTheme.colors.primary}>Content</StyledText>


            <Section theme={theme}>
                <StyledText fontSize='14px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>Text</StyledText>
                {/* <StyledInput
                    theme={theme}
                    $fontWeight='500'
                    color={theme.CorporateTheme.colors.headerColor}
                    value={tempSettings.htmlContent ?? tempSettings.paragraphContent ?? ''}
                    as="textarea"
                    placeholder="Lets Create Something Amazing Together"
                    onChange={(e) => updateTempSetting('htmlContent', e.target.value)}
                    style={{ background: theme.CorporateTheme.colors.background }}
                /> */}
                <StyledTextEditor
                    value={tempSettings.htmlContent ?? tempSettings.paragraphContent ?? ''}
                    onChange={(value) => updateTempSetting('htmlContent', value)} // Update Formik field value
                    placeholder={"Lets Create Something Amazing Together"}
                    isReadOnly={false}
                    minHeight={"500px"}
                    // isInvalid={isEmpty(value)}
                />
            </Section>

            <Section theme={theme}>
                <StyledText fontSize='14px' fontWeight={600} textColor={theme.CorporateTheme.colors.primary} className='mb-4 mt-2'>Styling</StyledText>

                <StyledText fontSize='14px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>Text Color</StyledText>
                <Row>
                    <ColorInput
                        type="color"
                        value={tempSettings.paragraphColor ?? '#000000'}
                        onChange={(e) => updateTempSetting('paragraphColor', e.target.value)}
                    />

                    <HexInput
                        theme={theme}
                        type="text"
                        value={tempSettings.paragraphColor ?? ''}
                        onChange={(e) => updateTempSetting('paragraphColor', e.target.value)}
                    />
                </Row>
            </Section>

            <div className='mt-4 pt-2'>
                <StyledHorizontalLine theme={theme} />
            </div>

            {/* <Section theme={theme}>
                <StyledText fontSize='13px' fontWeight={600} textColor={theme.CorporateTheme.colors.primary}>Text Alignment</StyledText>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}>
                    {textAlignmentOptions.map((alignment) => {
                        const value = alignment.id.toLowerCase();

                        return (
                            <AlignmentCard
                                key={value}
                                theme={theme}
                                $isSelected={tempSettings.paragraphTextAlignment === value}
                                onClick={() => updateTempSetting('paragraphTextAlignment', value)}
                            >
                                <StyledRadio borderWidth='2px' radioColor={theme.CorporateTheme.colors.primary} name="alignment" checked={tempSettings.paragraphTextAlignment === value} onChange={() => { }} label="" />
                                {alignment.icon}
                            </AlignmentCard>
                        );
                    })}
                </div>
            </Section> */}

            <Section theme={theme}>
                <StyledText fontSize='14px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>Font Size</StyledText>
                <FontSizeRow>
                    <FontSizeInput
                        $theme={theme}
                        type='number'
                        min='1'
                        inputMode='numeric'
                        value={paragraphFontSizeInput}
                        onChange={(e) => handleParagraphFontSizeChange(e.target.value)}
                        onBlur={handleParagraphFontSizeBlur}
                        placeholder='Enter font size here'
                    />
                    <FontSizeSuffix $theme={theme}>px</FontSizeSuffix>
                </FontSizeRow>
            </Section>

            {/* <Section theme={theme} className='mt-4 pt-2 mb-5'>
                <StyledText fontSize='14px' fontWeight={600} textColor={theme.CorporateTheme.colors.headerColor}>Font Weight</StyledText>
                <div>

                    <AMSSelect
                        showIcons
                        staticOptions={fontWeightOptions.map((weight) => ({ value: weight.toLowerCase(), label: weight }))}
                        placeholder="Font Weight"
                        value={tempSettings.paragraphFontWeight ? { value: tempSettings.paragraphFontWeight, label: tempSettings.paragraphFontWeight } : undefined}
                        onChange={(option) => {
                            updateTempSetting('paragraphFontWeight', (
                                option?.value !== undefined && option?.value !== null
                                    ? String(option.value)
                                    : undefined
                            ));
                        }}

                        defaultOptions
                    />
                </div>
            </Section> */}
        </Container>
    )
}

const Container = styled.div<{ theme: Theme }>`
    display: flex;
    flex-direction: column; 
    border-radius: 8px;
    padding: 16px;
    background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
    border: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
    `

const Section = styled.div<{ theme: Theme }>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 26px;
`;


const OptionsRow = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const OptionButton = styled.button<{ theme: Theme, $isSelected?: boolean }>`
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${({ theme, $isSelected }) =>
        $isSelected ? theme.CorporateTheme.colors.accentOrange : theme.CorporateTheme.colors.border};
    background-color: ${({ theme, $isSelected }) =>
        $isSelected ? hexToRgba(theme.CorporateTheme.colors.accentOrange, 0.1) : theme.CorporateTheme.colors.background};
    color: ${({ theme, $isSelected }) =>
        $isSelected ? theme.CorporateTheme.colors.accentOrange : theme.CorporateTheme.colors.textPrimary};
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    
    /* Remove margin */
    margin: 0;
    
    /* Default no border-radius */
    border-radius: 0;
    
    /* First button - rounded left corners */
    &:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }

    /* Last button - rounded right corners */
    &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }

    /* Remove double borders between buttons */
    &:not(:first-child) {
        margin-left: -1px;
    }

    /* IMPORTANT: Set z-index for all buttons to prevent overlap issues */
    position: relative;
    z-index: ${({ $isSelected }) => $isSelected ? 2 : 1};

    &:hover {
        background-color: ${({ theme }) => hexToRgba(theme.CorporateTheme.colors.accentOrange, 0.1)};
        border-color: ${({ theme }) => theme.CorporateTheme.colors.accentOrange};
        color: ${({ theme }) => theme.CorporateTheme.colors.accentOrange};
        z-index: 3; /* Higher z-index on hover */
    }

    /* Selected state styling */
    ${({ $isSelected, theme }) => $isSelected && `
        background-color: ${hexToRgba(theme.CorporateTheme.colors.accentOrange, 0.1)};
        border-color: ${theme.CorporateTheme.colors.accentOrange};
        color: ${theme.CorporateTheme.colors.accentOrange};
        font-weight: 600;
        z-index: 2;
    `}
`;

const TextInput = styled.input<{ theme: Theme }>`
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
    background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
    color: ${({ theme }) => theme.CorporateTheme.colors.textPrimary};
    font-size: 14px;
    
    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.CorporateTheme.colors.primary};
    }
    
    &::placeholder {
        color: ${({ theme }) => theme.CorporateTheme.colors.textSecondary};
    }
`;

const Select = styled.select<{ theme: Theme }>`
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
    background-color: ${({ theme }) => theme.CorporateTheme.colors.headerBG};
    color: ${({ theme }) => theme.CorporateTheme.colors.textPrimary};
    font-size: 14px;
    
    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.CorporateTheme.colors.primary};
    }
    
    option {
        background-color: ${({ theme }) => theme.CorporateTheme.colors.headerBG};
        color: ${({ theme }) => theme.CorporateTheme.colors.textPrimary};
    }
`;


const AlignmentCard = styled.button<{
    theme: any;
    $isSelected: boolean;
}>`
  display: flex;
  align-items: center;
    border:none;
  cursor: pointer;
    gap: 6px;
   background: ${({ theme }) => theme.CorporateTheme.colors.background};

  transition: all 0.2s ease;


`;

const HexInput = styled(Form.Control) <{ theme: Theme }>`
    flex: 1;
    height: 42px;
    background: transparent;
    color: ${({ theme }) => theme.CorporateTheme.colors.textSecondary};
    border: 1px solid ${({ theme }) => theme.CreateFormTheme.colors.inputBorders};
`;

const ColorInput = styled.input`
    width: 105px;
    height: 42px;
    border-radius: 8px;
    border: 1px solid #dcdcdc;
    cursor: pointer;
    padding: 0;
`;

const Row = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 20px;
`;

const FontSizeRow = styled.div`
    display: flex;
    align-items: stretch;
    width: 100%;
`;

const FontSizeInput = styled.input<{ $theme: Theme }>`
    flex: 1;
    height: 42px;
    padding: 0 12px;
    border: 1px solid ${({ $theme }) => $theme.CreateFormTheme.colors.inputBorders};
    border-right: none;
    border-radius: 5px 0 0 5px;
    background: ${({ $theme }) => $theme.CorporateTheme.colors.background};
    color: ${({ $theme }) => $theme.CorporateTheme.colors.textSecondary};
    font-size: 14px;
    outline: none;

    &:focus {
        border-color: ${({ $theme }) => $theme.CorporateTheme.colors.primary};
    }

    &[type='number']::-webkit-outer-spin-button,
    &[type='number']::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield;
    }
`;

const FontSizeSuffix = styled.div<{ $theme: Theme }>`
    min-width: 48px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ $theme }) => $theme.CreateFormTheme.colors.inputBorders};
    border-radius: 0 5px 5px 0;
    background: ${({ $theme }) => $theme.CorporateTheme.colors.filterBG};
    color: ${({ $theme }) => $theme.CorporateTheme.colors.textSecondary};
    font-size: 14px;
    font-weight: 500;
    user-select: none;
    padding-bottom: 5px;
`;



export default ParagraphProperties
